import { CampaignControlOptionApiGroup } from '@/Enums/ControlOptions/CampaignGroup.enum';
import ReportType from '@/Enums/Looker/ReportType.enum';
import { IBeeswaxCampaign } from '@/Interfaces/Beeswax/Campaign.interface';
import { IGroupedControlOption } from '@/Interfaces/ControlOption.interface';
import { IPacingReportRecord } from '@/Interfaces/Pacing/ReportRecord.interface';
import { IBaseDataReport } from '@/Interfaces/ReportingDashboard/Beeswax/Report.interface';
import { REPORT_ENDPOINT } from '@/constants/endpoints';
import { RootState } from '@/store';
import { AsyncThunkPayloadCreator } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { fetchLookerReport } from '../beeswaxReports';
import { getPacingFilters } from './slice';

export const beeswaxPacingReportHandler: AsyncThunkPayloadCreator<
  IBaseDataReport<IPacingReportRecord>,
  { signal?: AbortSignal }
> = async (payload, { getState }) => {
  const state = getState() as RootState;

  const apiFilter = getPacingFilters(state, CampaignControlOptionApiGroup.Beeswax);

  if (!apiFilter.advertiserIds?.length && !apiFilter.campaignIds?.length) {
    toast.error('No advertisers for omnichannel reports filters.');
    return { report: [] };
  }

  const reportResponseData = await fetchLookerReport({
    signal: payload?.signal,
    url: REPORT_ENDPOINT,
    body: {
      reportType: ReportType.Pacing,
      filters: apiFilter,
    },
  });

  return reportResponseData;
};

export const mapBeeswaxCampaigns = (campaigns: IBeeswaxCampaign[]): IGroupedControlOption[] => {
  return campaigns
    ?.map(campaign => ({
      value: campaign.campaign_id,
      label: campaign.campaign_name,
      groupLabel: CampaignControlOptionApiGroup.Beeswax,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};
